// extracted by mini-css-extract-plugin
export var Presentation = "index-module--Presentation--1DdU_";